export default class ServerError extends Error {
    constructor(errorObj) {
        super(errorObj);

        this.stack = new Error().stack;
        this.error = errorObj;
        this.name = errorObj.error.code;

        const { error: { message } = {}, echo_req } = errorObj;

        const echoStr = echo_req ? JSON.stringify(echo_req, null, 2) : '(no echo_req)';
        this.message = `[ServerError] ${message}\n${echoStr}`;
    }
}
